import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Code, Cpu, Globe } from "lucide-react";

const Hero = () => {
  return (
    <section className="container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="hero-content"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="badge"
        >
          Fullstack Developer • 2.5 Years Exp
        </motion.div>

        <h1 className="hero-title">
          Building Digital <br />
          <span className="gradient-text">Experiences</span> that Matter
        </h1>

        <p className="hero-subtitle">
          I'm a fullstack engineer dedicated to crafting high-performance,
          visually stunning web applications with modern tech stacks.
        </p>

        <div className="hero-actions">
          <a href="#projects" className="btn btn-primary">
            View My Work<ArrowRight size={18} />
          </a>
          {/* <a href="/resume.pdf" download className="btn btn-outline">
            <Download size={18} /> Download CV
          </a> */}
          {/* <a href="#contact" className="btn btn-outline">
            Contact Me
          </a> */}
          <a
            href="https://wa.me/918117012772?text=Hi%2C%20I%20visited%20your%20portfolio"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline"
          >
            Contact Me
          </a>
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <Globe className="stat-icon" />
            <span>Web3 & Cloud</span>
          </div>
          <div className="stat-item">
            <Code className="stat-icon" />
            <span>Fullstack Expert</span>
          </div>
          <div className="stat-item">
            <Cpu className="stat-icon" />
            <span>Problem Solver</span>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
